import React, { useEffect, useRef, useState } from "react";
import "./PopUpCalificar.css";
import Confetti from "react-confetti"; // (no se usa; lo dejo igual que en tu otro componente)
//import iconopopup2 from "../../assets/img/NotificacionesModales/modal PC.png";
//import iconopopupTablet2 from "../../assets/img/NotificacionesModales/modal tablet-02.png";
//import iconopopupCel2 from "../../assets/img/NotificacionesModales/modal celular.png";
//import iconopopup2 from "../../assets/img/NotificacionesModales/Modales_(Demoras_en _mañana se acredita_)_Tamaño_Pc2.png";
//import iconopopupTablet2 from "../../assets/img/NotificacionesModales/Modales_(Demoras_en _mañana se acredita_)_Tamaño_Celular2.png";
//import iconopopupCel2 from "../../assets/img/NotificacionesModales/Modales_(Demoras_en _mañana se acredita_)_Tamaño_Tablet2.png";
//import iconopopup2 from "../../assets/img/NotificacionesModales/modalpromopc2111.png";
//import iconopopupTablet2 from "../../assets/img/NotificacionesModales/modalpromotablet2111.png";
//import iconopopupCel2 from "../../assets/img/NotificacionesModales/modalpromocelular2111.png"; 
import iconopopup2 from "../../assets/img/NotificacionesModales/modal promo PC3112.png";
import iconopopupTablet2 from "../../assets/img/NotificacionesModales/modal promo tablet3112.png";
import iconopopupCel2 from "../../assets/img/NotificacionesModales/modal promo celular3112.png";
import { Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Fireworks } from "fireworks-js"; // (no se usa; lo dejo igual que en tu código original)

const PopUpNotificaciones3 = ({ onClose }) => {
    const containerRef = useRef(null);
    const modalRef = useRef(null);

    // ⬇️ Estados para saber si cada imagen se cargó (igual que en el otro popup)
    const [imgLoadedDesktop, setImgLoadedDesktop] = useState(false);
    const [imgLoadedTablet, setImgLoadedTablet] = useState(false);
    const [imgLoadedMobile, setImgLoadedMobile] = useState(false);

    const allImagesLoaded = imgLoadedDesktop && imgLoadedTablet && imgLoadedMobile;

    // ⬇️ Precarga de imágenes antes de mostrar el modal (mismo patrón)
    useEffect(() => {
        const img1 = new window.Image();
        const img2 = new window.Image();
        const img3 = new window.Image();

        img1.src = iconopopup2;
        img2.src = iconopopupTablet2;
        img3.src = iconopopupCel2;

        img1.onload = () => setImgLoadedDesktop(true);
        img2.onload = () => setImgLoadedTablet(true);
        img3.onload = () => setImgLoadedMobile(true);

        return () => {
            img1.onload = null;
            img2.onload = null;
            img3.onload = null;
        };
    }, []);

    // ⬇️ Solo cuando las imágenes ya están cargadas se bloquea el scroll y se muestra el modal
    useEffect(() => {
        if (!allImagesLoaded) return;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [allImagesLoaded]);

    // ⬇️ Manejador para el clic fuera del contenido del modal
    const handleOutsideClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    // ⬇️ NO RENDERIZA NADA hasta que estén todas las imágenes cargadas
    if (!allImagesLoaded) return null;

    return (
        <section>
            <div
                className="modalShadowNotificaciones centrado"
                onClick={handleOutsideClick}
                ref={containerRef}
            >
                {/* <Confetti width={window.innerWidth} height={window.innerHeight} /> */}
                <div className="caja-popup-notificaciones " ref={modalRef}>
                    <section className="d-flex justify-content-end mt-2">
                        <div className="me-1">
                            <button className="border-0 btn-filtro-cruz" onClick={onClose}>
                                <FontAwesomeIcon className="fs-18 " icon={faXmark} />
                            </button>
                        </div>
                    </section>

                    <article className="d-none d-lg-block">
                        <div className="text-center">
                            <Image
                                className="w-100"
                                src={iconopopup2}
                                alt="icono icono"
                                fluid
                            />
                            {/* <h6 className="text-center lato-bold fs-17"> Estimado Aliado</h6>
              <span className="text-center lato-bold fs-14">
                Te informamos que estamos procesando tus datos. Durante el día
                de hoy, verás actualizado el concepto de "mañana se acredita".
                <br />
                Agradecemos tu comprensión.
              </span> */}
                        </div>
                    </article>

                    <article className="d-lg-none d-block">
                        <div className="text-center">
                            <div className="d-none d-md-block">
                                <Image
                                    className="w-100"
                                    src={iconopopupTablet2}
                                    alt="icono icono"
                                    fluid
                                />
                                {/* <h6 className="text-center lato-bold fs-17"> Estimado Aliado</h6> */}
                                {/*<span className="text-center lato-bold fs-14">*/}
                                {/*Le informamos que, debido al feriado del próximo lunes 18/11 , los plazos y pagos se diferirán automáticamente al siguiente día hábil. */}
                                {/*</span>*/}
                                {/* <span className="text-center lato-bold fs-14">
                  Te informamos que estamos procesando tus datos. Durante el día
                  de hoy, verás actualizado el concepto de "mañana se acredita".
                  <br />
                  Agradecemos tu comprensión.
                </span> */}
                            </div>

                            <div className="d-md-none d-block">
                                <Image
                                    className="w-100"
                                    src={iconopopupCel2}
                                    alt="icono icono"
                                    fluid
                                />
                                {/* <h6 className="text-center lato-bold fs-14"> Estimado Aliado</h6>  */}
                                {/*  <span className="text-center lato-bold fs-12">*/}
                                {/*  Le informamos que, debido al feriado del próximo lunes 18/11 , los plazos y pagos se diferirán automáticamente al siguiente día hábil.                </span>*/}
                                {/* <span className="text-center lato-bold fs-12">
                  Te informamos que estamos procesando tus datos. Durante el día
                  de hoy, verás actualizado el concepto de "mañana se acredita".
                  <br />
                  Agradecemos tu comprensión.
                </span>  */}
                            </div>
                        </div>
                    </article>

                    <article className="px-4">
                        <button
                            className="btn-popUp lato-bold fs-18 my-2"
                            type="button"
                            onClick={onClose}
                        >
                            Cerrar
                        </button>
                    </article>
                </div>
            </div>
        </section>
    );
};

export default PopUpNotificaciones3;
